import { render } from "./IconPlus.vue?vue&type=template&id=5dd7bb6e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dd7bb6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dd7bb6e', __exports__)) {
    api.reload('5dd7bb6e', __exports__)
  }
  
  module.hot.accept("./IconPlus.vue?vue&type=template&id=5dd7bb6e", () => {
    api.rerender('5dd7bb6e', render)
  })

}


export default __exports__